import React, {useState, useEffect} from 'react';
import * as yup from 'yup';
import {t} from 'react-switch-lang';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import {format} from 'date-fns';
import InputYear from '../../components/FormFields/inputDate/InputYear';

const MonitoringOfImplementationRecommendations = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const schema = yup.object().shape({
    yearFrom: yup.object().nullable().required(t('message.fieldRequired')),
    yearTo: yup.object().nullable().required(t('message.fieldRequired')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {watch } = methods;
  const validFrom = watch('yearFrom');
  const validTo = watch('yearTo');

  useEffect(() => {
    setIsSubmitted(false);
  }, []);

  return (
    <div className="reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container" key={window.location.pathname}>
          <div className="row  ml-0 mr-0">
            <div className="form-group pr-5">
              <label className="label" htmlFor="yearFrom">
                {t('reports.yearFrom')}
              </label>
              <InputYear
                name="yearFrom"
                maxDate={validTo}
                placeholderText={t('reports.yearFromPlaceholder')}
              />
              {
                validFrom === null && isSubmitted === true
                  ? <span className="error-message position-absolute">{t('message.fieldRequired')}</span>
                  : ''
              }
            </div>
            <div className="form-group pr-5">
              <label className="label" htmlFor="yearTo">
                {t('reports.yearTo')}
              </label>
              <InputYear
                name="yearTo"
                minDate={validFrom}
                placeholderText={t('reports.yearToPlaceholder')}
              />
              {
                validTo === null && isSubmitted === true
                  ? <span className="error-message position-absolute">{t('message.fieldRequired')}</span>
                  : ''
              }
            </div>
            <DownloadBtn
              api={'reports/revision-recommendation-summary'}
              paramsLength={2}
              setIsSubmitted={(e) => setIsSubmitted(e)}
              apiParameters={{
                yearFrom:
                  validFrom !== null && validFrom !== undefined
                    ? `yearFrom=${encodeURIComponent(
                      format(validFrom, 'yyyy'))}`
                    : '',
                yearTo:
                  validTo !== null && validTo !== undefined
                    ? `yearTo=${encodeURIComponent(
                      format(validTo, 'yyyy'))}`
                    : '',
              }}
            />
          </div>
        </div>
      </FormProvider>
    </div>
  );
};

export default MonitoringOfImplementationRecommendations;